import { j as jsxRuntimeExports } from "./doenetml-CDvV96YD.js";
import React__default, { useState } from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-YzDSBjpZ.js";
const footnote = React__default.memo(function Footnote(props) {
  let { id, SVs } = useDoenetRenderer(props, false);
  let [isVisible, setIsVisible] = useState(false);
  if (SVs.hidden) {
    return null;
  }
  const footnoteMessageStyle = {
    padding: "10px",
    borderRadius: "5px",
    backgroundColor: "#e2e2e2",
    display: "block"
  };
  let footnoteMessage = "";
  if (isVisible) {
    footnoteMessage = /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: footnoteMessageStyle, children: SVs.text });
  }
  const buttonStyle = {
    backgroundColor: "white",
    border: "none"
  };
  const footnoteStyle = {
    textDecoration: "none",
    color: "#1A5A99"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { id, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("sup", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        style: buttonStyle,
        onClick: () => setIsVisible((was) => !was),
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("a", { href: "#", title: SVs.text, style: footnoteStyle, children: [
          "[",
          SVs.footnoteTag,
          "]"
        ] })
      }
    ) }),
    footnoteMessage
  ] });
});
export {
  footnote as default
};
